import { render, staticRenderFns } from "./AdministratorManagement.vue?vue&type=template&id=dba4cf00"
import script from "./AdministratorManagement.vue?vue&type=script&lang=js"
export * from "./AdministratorManagement.vue?vue&type=script&lang=js"
import style0 from "./AdministratorManagement.vue?vue&type=style&index=0&id=dba4cf00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports